function isValidSaIdNumber(value) {
  let idNumber = value;

  if (/[^0-9-\s]+/.test(idNumber)) {
    return false;
  }

  // ensure month and day are valid
  const month = parseInt(idNumber.substring(2, 4), 10);
  const day = parseInt(idNumber.substring(4, 6), 10);

  if (month < 1 || month > 12) {
    return false;
  }

  if (day < 1 || day > 31) {
    return false;
  }

  if (month === 2 && day === 29) {
    const year = parseInt(idNumber.substring(0, 2), 10);
    if (!(((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0))) {
      return false;
    }
  }

  idNumber = idNumber.replace(/\D/g, '');

  let oddSum = 0;
  let evenSequence = '';
  for (let n = 0; n < idNumber.length - 1; n += 2) {
    oddSum += parseInt(idNumber.charAt(n), 10);
  }
  for (let m = 1; m < idNumber.length; m += 2) {
    evenSequence += idNumber.charAt(m);
  }
  evenSequence = parseInt(evenSequence, 10) * 2;
  evenSequence = `${evenSequence}`;
  let totalEvenSequence = 0;
  for (let i = 0; i < evenSequence.length; i += 1) {
    totalEvenSequence += parseInt((`${evenSequence}`).charAt(i), 10);
  }

  const total = oddSum + totalEvenSequence;
  const secondDigit = parseInt((`${total}`).charAt(1), 10);
  let check = 10 - secondDigit;

  if (check > 9) {
    check = parseInt((`${check}`).charAt(1), 10);
  }

  return parseInt(idNumber.charAt(12), 10) === check;
}

export default (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }

  return isValidSaIdNumber(value);
};



// WEBPACK FOOTER //
// ./src/utils/validators/SaIdNumber.js